import React from "react";
const AuctionDescription = () => {
    return (
        <>
            <div className="row">
                <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                    <div className="_nft_content_desc_wrap">
                        <div className="_nft_content_card_inner">
                            <h3 className="_nft_content_desc_title">Descriptions</h3>
                            <p className="_nft_content_desc_p">Lorem Ipsum is simply dummy text of the printing and
                                typesetting industry. Lorem Ipsum has been the industry's standard dummy text
                                ever since the 1500s, when an unknown printer took a galley of type and
                                scrambled it to make a type specimen book. It has survived not only five
                                centuries, but also the leap into electronic typesetting, remaining essentially.
                                <a href="#0">
                                    See more
                                    <span className="_nft_content_info_li_ic">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22"
                                            fill="none" viewBox="0 0 32 32">
                                            <path stroke="#000" stroke-linecap="round" stroke-linejoin="round"
                                                stroke-width="2.354"
                                                d="M10.82 23.736h12.75V10.984m0 12.752L8.27 8.434l15.302 15.302Z" />
                                        </svg>
                                    </span>
                                </a>
                            </p>
                        </div>
                    </div>
                </div>

            </div>
        </>
    )
}
export default AuctionDescription;